
class SubscriptionCtrl {
    [x: string]: any; 
 	 static $inject = ['moment'];
    constructor(moment) {
        this.moment = moment;
    }

    $onInit() {
        this.subscription.timeAgo = this.moment.unix(this.subscription.periodEnd).fromNow();
    }

    discount() {
        return this.subscription.discountPercentage || this.subscription.discountDollars;
    }
}
export default {
    controller: SubscriptionCtrl,
    template : require('./subscription.html'),
    bindings: {subscription: "<"}
};
